import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atrius-app-bar-content',
  template: `
    <div>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentComponent {}
